import React from 'react';
import { Text, Flex, Link, Box, Button } from '@chakra-ui/react';
import TheLogo from '#coreComponents/logos/TheLogo';
import Heading from '#coreComponents/Heading';
// JME
// import { useAuthHook } from '#utils/useAuthHook';
// JME1
import { useAuth } from '#core/Auth';

const AccessDeniedErrorScreen: React.FC<{
  title?: string;
  text?: string;
  footerComponent?: React.FC<{}>;
}> = ({
  title = 'You do not have access to the DataPoints platform',
  text = 'You do not have access to the DataPoints platform.',
  footerComponent: FooterComponent,
}) => {
  const {
    canUseElevatedPermissions,
    useElevatedPermissions,
    setUseElevatedPermissions,
  } = useAuth(); // JME2
  return (
    <Flex
      direction="column"
      align="center"
      justify="center"
      height="100vh"
      textAlign="center"
    >
      <TheLogo w={100} mt={-12} />
      <Box p={4}>
        <Heading color="red.500" mt={8} mb={4}>
          {title}
        </Heading>
        <Text>{text}</Text>
        <Text>
          If you require support email{' '}
          <Link
            data-testid="support-email"
            color="pink.600"
            href="mailto:datapoints.support@timeshighereducation.com?subject=Service%20Unavailable"
            isExternal
          >
            datapoints.support@timeshighereducation.com
          </Link>
          .
        </Text>
        {canUseElevatedPermissions && !useElevatedPermissions && (
          <Box>
            <Text my={4}>
              This may be because you are not using elevated permissions and the
              current institution does not have access.{' '}
            </Text>
            <Button
              data-testid="turn-permissions-btn"
              variant="solid"
              colorScheme="pink"
              size="sm"
              onClick={() => setUseElevatedPermissions(true)}
            >
              Turn on elevated permissions
            </Button>
          </Box>
        )}
      </Box>
      {FooterComponent && <FooterComponent />}
    </Flex>
  );
};

export default AccessDeniedErrorScreen;
